import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { DatabaseService } from '../database.service';
import { environment } from "../../../environments/environment";
import { Observable, catchError, tap, throwError } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export  class ResourceService {
  private  APIUrl = environment.apiUrl;
  
  constructor(
    protected httpClient: HttpClient,
    private databaseService: DatabaseService
  ) {
    this.APIUrl = environment.apiUrl;
  }

  _get(url:string, data: any)  {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.get(`${renderUrl}`).pipe(
      catchError(this.handleError)
    );
  }

  get(url:string, data: any)  {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.get(`${this.APIUrl}${renderUrl.urlWithParams}`).pipe(
      catchError(this.handleError)
    );
  }

  getActivePacients(url:string)  {
    let renderUrl = this.renderUrl(url, null);
    return this.httpClient.get(`${this.APIUrl}${renderUrl.urlWithParams}`).pipe(
      catchError(this.handleError)
    );
  }  

  // Realiza la solicitud HTTP GET y devuelve los datos
  fetchData(url:string): Observable<any> {
    return this.httpClient.get(`${this.APIUrl}${url}`)
    //.pipe(
    //  tap((data) => {
        // Puedes agregar lógica aquí para manipular los datos antes de devolverlos
    //  }),
    //  catchError(this.handleError)
    //);
  }

  getAll(url:string)  {
    return this.httpClient.get(`${this.APIUrl}${url}`) ;
  }  


  private handleError(error: HttpErrorResponse) {
    // Aquí puedes manejar el error de acuerdo a tus necesidades
    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      console.error('Error del lado del cliente:', error.error.message);
    } else {
      // Error del lado del servidor
      console.error('Error del lado del servidor:', error.status, error.error);
    }

    // Puedes lanzar un nuevo error personalizado o devolver un valor predeterminado
    // En este ejemplo, simplemente relanzamos el error
    return throwError(() => new Error ('Hubo un error en la solicitud. Por favor, inténtalo de nuevo.'));
  }

  newget(url:string, data: any)  { // este get se usó para poder ver bien los parametros y urls
    let renderUrl = this.renderUrl(url, data);
    let myquery = this.APIUrl+renderUrl.urlWithParams;
    return this.httpClient.get(`${this.APIUrl}${renderUrl.urlWithParams}`) ;
  }
  
  post(url: string, data: any) {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.post(`${this.APIUrl}${renderUrl.url}`, renderUrl.body);
  }

  postImage(url: string, data) {
    let renderUrl = this.renderUrl(url, {});
    return this.httpClient.post(`${this.APIUrl}${renderUrl.url}`, data);
  }

  delete(url: string, data: any) {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.delete(`${this.APIUrl}${renderUrl.url}`);
  }

  put(url: string, data: any) {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.put(`${this.APIUrl}${renderUrl.url}`,data);
  }

  patch(url: string, data: any) {
    let renderUrl = this.renderUrl(url, data);
    return this.httpClient.patch(`${this.APIUrl}${renderUrl.url}`,data);
  }
  
  private Api(){
    this.APIUrl = this.databaseService.get('api');
  }

  private renderUrl(template: string, data: any) {
    if(!data) return { url: template, urlWithParams: template, body: undefined };
    const regex = /([^:])+([^\/])+/ig;
    var parts = [];
    var usedVars = [];
    var queryParams = [];
    var body = {};
    var m;
    while ((m = regex.exec(template)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
          regex.lastIndex++;
      }
      var p = m[0].split(':');
      parts.push(p[0]);
      if(p.length > 1) {
        var v = p[1];
        parts.push(data[v]);
        usedVars.push(v);
      }
    }
    for(var k in data) {
      if(usedVars.indexOf(k) < 0) {
        queryParams.push(k + '=' + data[k]);
        body[k] = data[k];
      }
    }
    var url = parts.join('');
    var urlWithParams = url;
    if(queryParams.length > 0) {
      urlWithParams += '?' + queryParams.join('&');
    }
    return { url: url, urlWithParams: urlWithParams, body: body };
  }
}